import React from 'react';
import StudentLayout from "@/components/layout/student/studentLayout";
import {Button} from "antd";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useApiCreateStudentPaymentGenerate} from "@/api/payment";
import toFaNumber, {toFaNumberFormat} from "@/lib/utils/number";
import {urlPath} from "@/lib/utils/url";
import {URLS} from "@/lib/urls";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import TableSearch from "@/components/table/tableSearch";
import {useApiSearchStudentInstallments} from "@/api/installment";
import {InstallmentPayStatusEnum} from "@/lib/helper/enumType";
import {useAuth} from "@/provider/AuthProvider";
import LowBudgetAlertPay from "@/components/low-budget-alert-pay/LowBudgetAlertPay";

function StudentInstallmentListPage() {

    const {mutate: StartPayment, isPending} = useApiCreateStudentPaymentGenerate();

    const {dashboard} = useAuth();

    function payInstallment(installment_id, amount) {


        StartPayment({
            amount: amount,
            callback_url: urlPath(),
            pay_type: 'online',
            subtype: 'pay_installment',
            installment_id: installment_id,

        }, {
            onSuccess: data => {
                ApiHandleSuccessMessage(data)
                if (data?.data?.data?.redirect_url) {

                    window.location.href = data?.data?.data?.redirect_url;
                }

            },
            onError: error => {
                ApiHandleErrorMessage(error);
            }
        })
    }

    const columns = [
        {
            title: 'شناسه',
            dataIndex: 'id',
            key: 'id',
            responsive: ['md'],
            render: (text) => toFaNumber(text)
        },
        {
            title: 'مبلغ',
            dataIndex: 'price',
            key: 'price',
            render: (text, record) => {
                if (parseInt(record?.price) > 0) {
                    return (<span className={'text-blue-600'}>{toFaNumberFormat(record.price)}</span>)
                }
            }
        },

        {
            title: 'تاریخ سررسید',
            dataIndex: 'duedate',
            key: 'duedate',
            render: (text) => convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD')
        },

        {
            title: 'وضعیت پرداخت',
            dataIndex: 'pay_status',
            key: 'pay_status',

            render: (text) => {
                return (<><span
                    className={InstallmentPayStatusEnum(text, 'color')}>{InstallmentPayStatusEnum(text)}</span> </>)
            }
        },

        {
            title: 'تاریخ پرداخت',
            dataIndex: 'date_payed',
            key: 'date_payed',
            responsive: ['md'],
            render: (text, record) => {
                if (text) {
                    return convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD HH:mm:ss')
                }

            }
        },
        {
            title: ' ',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                if (!record?.date_payed) {
                    return <Button
                        onClick={() => payInstallment(record.id, record.price)}
                        loading={isPending}
                        size={'small'} variant={'solid'} color={'primary'}>پرداخت </Button>
                }
            }
        },
    ];

    return (
        <StudentLayout pageTitle={'لیست اقساط'} backTo={URLS.student.dashboard}>
            <LowBudgetAlertPay budget={dashboard?.budget}/>

            <TableSearch
                searchInput={false}
                apiFn={useApiSearchStudentInstallments}
                columns={columns}
                scroll={{x: true}}
                responsive={true}
            />
        </StudentLayout>

    );
}

export default StudentInstallmentListPage;


